module.exports = __webpack_public_path__ + "img/warning.6065dfd7.svg";